import contentRequest from '~/src/api/requests/contentRequest';

export function getTvChannelPackages(citydomain) {
    return contentRequest.getWithCache(`/${citydomain}/v1/channels/packages`);
}
